module.exports = "https://r.nearpod.com/assets/media/image/google-slides-icon-39abf13c7258d45080c306dc04b5eb46.svg";